import { useState } from 'react';
import { useSelector } from 'react-redux';
import { UserRoundPen } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import EditProfileForm from './EditProfileForm';
import { IUser } from '../auth';
import { selectUserId } from '../auth.slice';

interface EditProfileModalProps {
  user: IUser | undefined;
}

// High cyclomatic count comes from the defaultValues field-fallback chain
// (?? / || per preference), not branching logic.
// fallow-ignore-next-line complexity
function EditProfileModal({ user }: EditProfileModalProps) {
  const currentUser = useSelector(selectUserId);
  const [dialogOpen, setDialogOpen] = useState(false);
  if (!user || !currentUser || currentUser !== user._id) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <></>;
  }

  return (
    <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
      <DialogTrigger asChild>
        <Button className="w-full">
          <UserRoundPen className="mr-2 h-4 w-4" />
          Edit Profile
        </Button>
      </DialogTrigger>
      <DialogContent className="max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Edit Profile</DialogTitle>
        </DialogHeader>
        <EditProfileForm
          defaultValues={{
            firstname: user.firstname,
            lastname: user.lastname,
            profilePicture: user.profilePicture || '',
            socialLinks: {
              website: user.socialLinks?.website || user.website || '',
              youtube: user.socialLinks?.youtube || '',
              instagram: user.socialLinks?.instagram || '',
              facebook: user.socialLinks?.facebook || '',
              tiktok: user.socialLinks?.tiktok || '',
              x: user.socialLinks?.x || '',
            },
            privacy: {
              email: user.privacy?.email ?? true,
              firstname: user.privacy?.firstname ?? true,
              lastname: user.privacy?.lastname ?? true,
              links: user.privacy?.links ?? user.privacy?.website ?? true,
            },
            notificationPreferences: {
              coinsEarned: user.notificationPreferences?.coinsEarned ?? true,
              newPosts: user.notificationPreferences?.newPosts ?? true,
            },
          }}
          handleDialog={setDialogOpen}
        />
      </DialogContent>
    </Dialog>
  );
}

export default EditProfileModal;
